import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../../contexts/AuthContext";

/**
 * Renders children for signed-in users; guests go to chat (acquisition home).
 */
export default function SignedInRoute({ children, guestRedirect = "/" }) {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div className="signed-in-route-loading">
        <p className="school-muted">Laden…</p>
      </div>
    );
  }

  if (!user) {
    return <Navigate to={guestRedirect} replace />;
  }

  return children;
}
